import { IMAGES, INVOLVEMENT_CONTENT } from '../data/content'

function PartnersPage() {
    const schools = [
        'Dimensions Collaborative',
        'Helix High School',
        'Monarch School',
        'Monte Vista High School',
        'Montgomery High School',
        'Mount Miguel High School',
        'Olympian High School',
    ]

    const sponsors = [
        { name: 'CSE UCSD', image: '/images/cseucsdlogo.png', url: 'https://cse.ucsd.edu/' },
        { name: 'CSTA San Diego', image: '/images/CSTA LOGO.png', url: 'https://sandiego.csteachers.org/home' },
        { name: 'UC San Diego CREATE', image: '/images/createlogo.png', url: 'https://create.ucsd.edu/' },
        { name: 'Code.org', image: '/images/codelogo.png', url: 'https://code.org/en-US' },
        { name: 'IDEA Engineering Student Center', image: '/images/idealogo.png', url: 'https://jacobsschool.ucsd.edu/idea' },
        { name: 'Google Cloud', image: '/images/googlecloudlogo.png', url: 'https://cloud.google.com/' },
        { name: 'NetApp', image: '/images/netapplogo.png', url: 'https://www.netapp.com/' },
        { name: 'Trace3', image: '/images/trace3logo.png', url: 'https://www.trace3.com/' },
    ]

    return (
        <div className="pt-24 bg-gradient-to-b from-white via-brand-blue-light/10 to-brand-blue-light/30 min-h-screen">
            {/* Partners Hero Section */}
            <section className="relative py-16 px-4 overflow-hidden">
                {/* Decorative blob - right side */}
                <svg
                    className="absolute top-20 right-0 w-[500px] h-[600px] text-brand-blue opacity-20"
                    viewBox="0 0 200 250"
                    fill="currentColor"
                >
                    <ellipse cx="150" cy="100" rx="80" ry="90" />
                    <ellipse cx="120" cy="180" rx="70" ry="60" />
                    <ellipse cx="180" cy="150" rx="50" ry="70" />
                </svg>

                {/* Decorative curved line */}
                <svg
                    className="absolute top-1/2 right-20 w-[200px] h-[300px] text-brand-blue opacity-30 hidden lg:block"
                    viewBox="0 0 100 150"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                >
                    <path d="M10,0 Q90,50 50,75 Q10,100 90,150" />
                </svg>

                {/* Plus signs */}
                <div className="absolute right-1/4 bottom-20 hidden lg:block">
                    <svg className="w-6 h-6 text-brand-blue opacity-50" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                    </svg>
                </div>

                {/* Small dots */}
                <div className="absolute right-1/3 top-1/3 hidden lg:block">
                    <div className="w-3 h-3 rounded-full bg-brand-blue opacity-50"></div>
                </div>

                <div className="max-w-[1400px] mx-auto px-6">
                    <div className="grid lg:grid-cols-2 gap-16 items-start">
                        {/* Text Content */}
                        <div className="lg:pt-8">
                            <h1 className="text-4xl md:text-5xl font-heading font-bold text-brand-blue mb-2">
                                PARTNERS
                            </h1>
                            <div className="w-32 h-1 bg-brand-blue mb-8"></div>

                            <p className="text-lg text-gray-700 leading-relaxed mb-8 max-w-lg">
                                We partner with K-12 schools in the San Diego community to host workshops and mentorship programs. If you are an educator and you'd like to be involved with our organization, email us at{' '}
                                <a href="mailto:csforeac@ucsd.edu" className="text-brand-blue hover:underline">
                                    csforeac@ucsd.edu
                                </a>{' '}
                                or fill out our contact form and we will follow up with you!
                            </p>

                            <a
                                href={INVOLVEMENT_CONTENT.contactFormUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-primary-solid rounded-lg"
                            >
                                CONTACT FORM
                            </a>
                        </div>

                        {/* Polaroid Photos */}
                        <div className="relative h-[450px] hidden lg:block">
                            {/* Photo 1 - top */}
                            <div
                                className="absolute top-0 left-1/4 transform -rotate-3 bg-white p-3 shadow-xl z-10"
                                style={{ width: '280px' }}
                            >
                                <div className="aspect-[4/3] bg-gray-300 overflow-hidden">
                                    <img
                                        src="/images/TritonHacks2.png"
                                        alt="Workshop classroom"
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div className="h-8"></div>
                            </div>

                            {/* Photo 2 - bottom right, overlapping */}
                            <div
                                className="absolute top-48 left-1/3 transform rotate-3 bg-white p-3 shadow-xl z-20"
                                style={{ width: '260px' }}
                            >
                                <div className="aspect-[4/3] bg-gray-300 overflow-hidden">
                                    <img
                                        src="/images/TritonHacks7.png"
                                        alt="Students at computers"
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div className="h-8"></div>
                            </div>
                        </div>
                    </div>

                    {/* Schools Section */}
                    <div className="mt-16 lg:mt-8">
                        <h2 className="text-2xl md:text-3xl font-heading font-bold text-gray-900 mb-8">
                            SCHOOLS WE WORK WITH
                        </h2>

                        <div className="grid md:grid-cols-2 gap-x-16 gap-y-3 max-w-2xl">
                            {schools.map((school, index) => (
                                <div key={index} className="flex items-center gap-3">
                                    <span className="text-brand-blue font-bold text-lg">»</span>
                                    <span className="text-gray-700 text-lg">{school}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Sponsors Section */}
            <section className="py-20 px-4 bg-white">
                <div className="max-w-[1200px] mx-auto text-center">
                    <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-blue mb-2">
                        SPONSORS
                    </h2>
                    <div className="w-32 h-1 bg-brand-blue mx-auto mb-6"></div>

                    <p className="text-gray-600 text-lg mb-12">
                        Learn more about the amazing organizations and companies that support us!
                    </p>

                    {/* Sponsor Logos Grid */}
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-items-center">
                        {sponsors.map((sponsor, index) => (
                            <a
                                key={index}
                                href={sponsor.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-full pt-8 flex items-center justify-center p-4 transition-all hover:scale-105"
                            >
                                <img
                                    src={sponsor.image}
                                    alt={sponsor.name}
                                    className="max-h-28 w-auto object-contain"
                                />
                            </a>
                        ))}
                    </div>
                </div>
            </section>


            {/* Become a Sponsor Section */}
            <section className="relative py-20 px-4 bg-gradient-to-b from-white to-brand-blue-light/20 overflow-hidden">
                {/* Decorative blob */}
                <svg
                    className="absolute -bottom-20 -left-20 w-[400px] h-[300px] text-brand-blue opacity-15"
                    viewBox="0 0 200 150"
                    fill="currentColor"
                >
                    <ellipse cx="100" cy="80" rx="90" ry="60" />
                    <ellipse cx="50" cy="100" rx="50" ry="40" />
                </svg>

                <div className="max-w-[800px] mx-auto text-center relative z-10">
                    <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-blue mb-2">
                        BECOME A SPONSOR
                    </h2>
                    <div className="w-32 h-1 bg-brand-blue mx-auto mb-6"></div>

                    <p className="text-gray-700 text-lg mb-8 leading-relaxed">
                        Interested in supporting CS foreach and helping us expand our reach to more students?
                        We'd love to hear from you! Your sponsorship helps us provide free computer science
                        education to underserved K-12 students in San Diego.
                    </p>

                    <a
                        href={INVOLVEMENT_CONTENT.contactFormUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary-solid rounded-lg"
                    >
                        SPONSOR CONTACT FORM
                    </a>
                </div>
            </section>
        </div>
    )
}

export default PartnersPage
